
import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../config/site';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../App';

const Hero: React.FC = () => {
  const { t, openBooking } = useLanguage();
  return (
    <section className="relative min-h-[85vh] sm:min-h-screen w-full flex flex-col items-center justify-center overflow-hidden bg-primary pt-24 pb-12 sm:pt-40">
      {/* Cinematic Background Layer */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(205,127,50,0.12)_0%,_rgba(8,8,8,1)_80%)]"></div>
        <div className="absolute top-0 left-0 w-full h-full opacity-[0.1] bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-7xl mx-auto flex flex-col items-center w-full">
        <span className="block text-accent font-black tracking-[0.4em] mb-4 sm:mb-8 text-[9px] sm:text-[10px] animate-fade-up uppercase opacity-60">
          {t.tagline}
        </span>
        
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-serif font-bold text-white mb-8 sm:mb-12 leading-[1.1] tracking-tight uppercase max-w-4xl">
          <span className="inline-block animate-slide-left accent-text-gradient">{t.heroSignature}</span> <br /> 
          <span className="inline-block animate-slide-right italic delay-1 text-white/95 mt-1 sm:mt-4">{t.heroArtistry}</span>
        </h2>

        {/* Action Buttons - Pure conversion focus */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center animate-fade-up delay-3 w-full sm:w-auto px-4 sm:px-0">
          <button 
            onClick={openBooking}
            className="w-full sm:w-auto px-12 py-5 bg-accent text-black font-black uppercase tracking-[0.3em] text-[10px] hover:bg-white transition-all duration-700 shadow-2xl hover:-translate-y-1 text-center"
          >
            {t.reserveExperience}
          </button>
          <Link 
            to="/gallery"
            className="w-full sm:w-auto px-12 py-5 border border-white/10 text-white/40 font-black uppercase tracking-[0.3em] text-[10px] hover:border-accent hover:text-accent transition-all duration-700 text-center hover:-translate-y-1"
          >
            {t.exploreMastery}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce opacity-20 hidden sm:block">
        <ChevronDown size={24} className="text-accent" />
      </div>
    </section>
  );
};

export default Hero;
